module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6r5n9n3r-4d93aba15f75680f1c1e1321a9f317cf.svg";